// components/CheckboxField.tsx
import { Checkbox as MuiCheckbox, FormControlLabel, FormHelperText, useMediaQuery, useTheme } from '@mui/material';
import { Controller, Control } from 'react-hook-form';

interface Props {
  name: string;
  control: Control<any>;
  label?: React.ReactNode;
  size?: 'medium' | 'small' | 'large';
}

export default function Checkbox({ name, control, label, size }: Props) {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const responsiveSize = size || (isLargeScreen ? 'medium' : 'small');

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <FormControlLabel
            control={<MuiCheckbox {...field} size={responsiveSize} checked={field.value} />}
            label={label}
          />
          {error && <FormHelperText error>{error.message}</FormHelperText>}
        </>
      )}
    />
  );
}
